export interface Project {
  id: number;
  title: string;
  category: string;
  location: string;
  year: string;
  area: string;
  description: string;
  tags: string[];
  img: string;
  imgs: string[];
  videos?: string[];
}

export const projects: Project[] = [
  {
    id: 1,
    title: 'Galpón Multipropósito para Fundo La Colmena',
    category: 'Galpones Industriales',
    location: 'Fundo La Colmena, Araucanía',
    year: '2025',
    area: '2.400 m²',
    description: 'Construcción de galpón multipropósito en Fundo La Colmena y Fundo Aguas y Arena. Estructura metálica de gran envergadura con cubierta termoacústica, revestimientos laterales y terminaciones completas. Proyecto diseñado para operación agrícola e industrial con altos estándares de calidad y durabilidad en la zona rural de la Araucanía.',
    tags: ['Galpón multipropósito', 'Fundo La Colmena', 'Estructura metálica', 'Agrícola'],
    img: 'https://public.readdy.ai/ai/img_res/edited_709c45eb2f511fccb8514bc1e88dda5f_49a5c4f4.jpg',
    imgs: [
      'https://i.imgur.com/74nDCVh.jpeg',
      'https://i.imgur.com/6TuytXo.jpeg',
      'https://i.imgur.com/GYiqogy.jpeg',
      'https://i.imgur.com/Vf55zSc.jpeg',
      'https://i.imgur.com/xv8FjXG.jpeg',
      'https://i.imgur.com/z9b7bfK.jpeg',
      'https://i.imgur.com/8belZ9E.jpeg',
      'https://storage.readdy-site.link/project_files/e9e9255d-4fa4-42a2-878c-87b7e92a4901/c59361ee-f8cb-407a-b89d-5a10e9c6648c_Galpon-en-fundo-aguasyarena-1.jpeg?v=8dd509327d1f58401620504c9bfdfd33',
      'https://storage.readdy-site.link/project_files/e9e9255d-4fa4-42a2-878c-87b7e92a4901/b2585226-8ee0-4397-9867-66bbe89ffbd1_Galpon-en-fundo-aguasyarena-2.jpeg?v=bc35c3ceac97a9963b61e20a12d306f0',
      'https://storage.readdy-site.link/project_files/e9e9255d-4fa4-42a2-878c-87b7e92a4901/fca30729-10c2-43d2-8979-5abc28944954_Galpon-en-fundo-aguasyarena-3.jpeg?v=5460c421cc2c0013b283af1954547083',
      'https://storage.readdy-site.link/project_files/e9e9255d-4fa4-42a2-878c-87b7e92a4901/554b293b-6b73-44aa-8e27-7356d349236e_Galpon-en-fundo-aguasyarena-4.jpeg?v=8e1e2641773980936f241b96e3bd223f',
    ],
  },
  {
    id: 2,
    title: 'Galpón Multipropósito para Arándanos y Avellanos en Los Ángeles',
    category: 'Galpones Industriales',
    location: 'Los Ángeles, Biobío',
    year: '2025',
    area: '1.800 m²',
    description: 'Construcción de galpón multipropósito diseñado específicamente para el procesamiento y almacenamiento de arándanos y avellanos en la zona de Los Ángeles. Estructura metálica con cubierta termoacústica, revestimientos laterales y sistemas de ventilación especializados para la conservación de frutos de exportación.',
    tags: ['Galpón multipropósito', 'Agrícola', 'Exportación', 'Los Ángeles'],
    img: 'https://public.readdy.ai/ai/img_res/edited_ddbc2a8f1617f3384193da00c53b3d15_2eeb875b.jpg',
    imgs: [
      'https://i.imgur.com/StVrPvF.jpeg',
      'https://i.imgur.com/FsPp9lF.jpeg',
      'https://i.imgur.com/OqsuPyT.jpeg',
      'https://i.imgur.com/zymtBWu.jpeg',
      'https://i.imgur.com/X75EmEt.jpeg',
    ],
  },
  {
    id: 3,
    title: 'Obra en Centro de Temuco',
    category: 'Obras Civiles',
    location: 'Centro de Temuco, Araucanía',
    year: '2025',
    area: '1.200 m²',
    description: 'Obra de construcción ejecutada en el centro de la ciudad de Temuco. Proyecto de obra civil con estructuras metálicas, obras de albañilería, instalaciones y terminaciones completas en zona urbana de alta densidad, cumpliendo con todas las normativas municipales y de seguridad.',
    tags: ['Obra civil', 'Centro urbano', 'Temuco', 'Construcción'],
    img: 'https://public.readdy.ai/ai/img_res/edited_a2ee465b06ed9da6d68de9a1c47ed87b_23e22ea1.jpg',
    imgs: [
      'https://i.imgur.com/nzxqP3x.jpeg',
      'https://i.imgur.com/9PT01qq.jpeg',
      'https://i.imgur.com/WB00PID.jpeg',
      'https://i.imgur.com/vsk3ef9.jpeg',
    ],
  },
  {
    id: 5,
    title: 'Mall Chino Concepción — Camino a Coronel',
    category: 'Locales Comerciales',
    location: 'Concepción, Biobío',
    year: '2024',
    area: '2.800 m²',
    description: 'Construcción en parte del Mall Chino ubicado en el camino a Coronel, Concepción. Gran centro comercial con estructura metálica, amplios espacios comerciales y terminaciones de primera calidad para el retail asiático en la región del Biobío.',
    tags: ['Mall comercial', 'En construcción', 'Retail', 'Coronel'],
    img: 'https://public.readdy.ai/ai/img_res/edited_61fc91c86584d61b95aa55f6b478f54c_f55c2b65.jpg',
    imgs: [
      'https://storage.readdy-site.link/project_files/e9e9255d-4fa4-42a2-878c-87b7e92a4901/6f4f9b2a-0b79-445b-9d41-e3b6347224c8_Mall-chino-Conce-camino-a-coronel-1.jpg?v=7c511a60d3be923d56d2c7d29e8242da',
      'https://i.imgur.com/G21q8z2.jpeg',
      'https://i.imgur.com/2sIVsae.jpeg',
      'https://i.imgur.com/fQ9U7ta.jpeg',
      'https://i.imgur.com/Yy6ZQh6.jpeg',
    ],
    videos: [
      'https://storage.readdy-site.link/project_files/e9e9255d-4fa4-42a2-878c-87b7e92a4901/135ddad5-cca2-49f3-88ab-89410318b54b_Mall-chino-Conce-camino-a-coronel-1.mp4?v=a410c360e477c90b94c045a270d24cbd',
      'https://storage.readdy-site.link/project_files/e9e9255d-4fa4-42a2-878c-87b7e92a4901/5991518e-87ed-43f3-a0b2-3cd1c26e0ca3_Mall-chino-Conce-camino-a-coronel-2.mp4?v=e1233a4be424e17b097e2447e469a86e',
    ],
  },
  {
    id: 6,
    title: 'Galpón Multipropósito Los Ángeles',
    category: 'Galpones Industriales',
    location: 'Los Ángeles, Biobío',
    year: '2024',
    area: '2.000 m²',
    description: 'Construcción de galpón multipropósito de estructura metálica en Los Ángeles. Proyecto versátil diseñado para uso agrícola e industrial, con cubierta de alta resistencia, revestimientos laterales y terminaciones de calidad que permiten su adaptación a diversas actividades productivas en la región del Biobío.',
    tags: ['Galpón multipropósito', 'Estructura metálica', 'Los Ángeles', 'Uso versátil'],
    img: 'https://public.readdy.ai/ai/img_res/edited_6776b2c349446bc693c7b36bdc6e1402_00bd27fe.jpg',
    imgs: [
      'https://i.imgur.com/dIBlqNJ.jpeg',
      'https://i.imgur.com/OWKjJex.jpeg',
      'https://i.imgur.com/HMSJTJm.jpeg',
    ],
  },
  {
    id: 7,
    title: 'Galpón Multipropósito Temuco',
    category: 'Galpones Industriales',
    location: 'Temuco, Araucanía',
    year: '2024',
    area: '1.500 m²',
    description: 'Construcción de galpón multipropósito en Temuco. Estructura metálica con cubierta, revestimientos laterales y terminaciones de alta calidad para uso industrial y agrícola. Proyecto ejecutado con los más altos estándares de construcción en la capital de la Araucanía.',
    tags: ['Galpón multipropósito', 'Temuco', 'Estructura metálica', 'Uso industrial'],
    img: 'https://public.readdy.ai/ai/img_res/edited_41276ba5fdd0dfc87fe10e6b65b3134c_00bd27fe.jpg',
    imgs: [
      'https://i.imgur.com/Qyyiofl.jpeg',
      'https://i.imgur.com/JSR27P6.jpeg',
      'https://i.imgur.com/1X3QqIV.jpeg',
      'https://i.imgur.com/kex7Vri.jpeg',
      'https://i.imgur.com/MRFXIhB.jpeg',
      'https://i.imgur.com/ONoMevd.jpeg',
    ],
  },
  {
    id: 8,
    title: 'Remodelación Planta Exportadora de Fruta Collipulli',
    category: 'Estructuras Metálicas',
    location: 'Collipulli, Araucanía',
    year: '2024',
    area: '2.200 m²',
    description: 'Remodelación integral de planta exportadora de fruta en Collipulli. El proyecto incluyó la ampliación de estructuras metálicas, renovación de instalaciones de frío, optimización de espacios de procesamiento y modernización de la infraestructura para cumplir con los estándares de exportación internacional.',
    tags: ['Remodelación', 'Planta exportadora', 'Fruta', 'Collipulli'],
    img: 'https://public.readdy.ai/ai/img_res/edited_3b6ec7c6fefde5eac2f541de13287299_f06a19b9.jpg',
    imgs: [
      'https://i.imgur.com/Dz2W9Ba.jpeg',
      'https://i.imgur.com/DVwQe3s.jpeg',
      'https://i.imgur.com/KCdImiu.jpeg',
    ],
    videos: [
      'https://i.imgur.com/GthUliY.mp4',
      'https://i.imgur.com/SkTGFlV.mp4',
    ],
  },
  {
    id: 9,
    title: 'Planta Canada House — Martabid',
    category: 'Estructuras',
    location: 'Parque Industrial Lautaro, Araucanía',
    year: '2023',
    area: '1.100 m²',
    description: 'Aporte con montaje e instalación de plancha de construcción para la planta Canada House de Martabid en el Parque Industrial de Lautaro. Trabajo especializado en estructuras metálicas y cerramientos industriales de alta precisión.',
    tags: ['Montaje industrial', 'Plancha de construcción', 'Estructura metálica', 'Lautaro'],
    img: 'https://storage.readdy-site.link/project_files/e9e9255d-4fa4-42a2-878c-87b7e92a4901/6eb3ddae-0f91-4078-8ce3-95d4438f82d1_Montaje-e-instalacin-de-planchas-estructurales-en-la-infraestructura-correspondiente-al-proyecto-Mar.jpg?v=3ec1d69cdce60059ddae2838ff602a8c',
    imgs: [
      'https://storage.readdy-site.link/project_files/e9e9255d-4fa4-42a2-878c-87b7e92a4901/8ea9d247-8de3-44c2-8475-25af2639c71b_Montaje-e-instalacin-de-planchas-estructurales-en-la-infraestructura-correspondiente-al-proyecto-Mar.jpg?v=3c28145921fa3fb3e6916c54b8a56ddb',
      'https://storage.readdy-site.link/project_files/e9e9255d-4fa4-42a2-878c-87b7e92a4901/b4451375-e128-49ce-bcfe-f04210ee3de6_Montaje-e-instalacin-de-planchas-estructurales-en-la-infraestructura-correspondiente-al-proyecto-Mar.jpg?v=1a6a13a3cd850967805e2b9b9c649a69',
      'https://storage.readdy-site.link/project_files/e9e9255d-4fa4-42a2-878c-87b7e92a4901/6118a054-81eb-4f2e-9528-845a8f6f134a_Montaje-e-instalacin-de-planchas-estructurales-en-la-infraestructura-correspondiente-al-proyecto-Mar.jpg?v=6ec0c93e06abfe6e42f0f41046a7d473',
      'https://storage.readdy-site.link/project_files/e9e9255d-4fa4-42a2-878c-87b7e92a4901/cbfb2de2-ae7b-4c34-b8f8-1ad34875483c_Montaje-e-instalacin-de-planchas-estructurales-en-la-infraestructura-correspondiente-al-proyecto-Mar.jpg?v=1c3c10c3a7d05257b223ad5ddb466166',
    ],
  },
  {
    id: 10,
    title: 'Fabricación Estructura para Pasarelas Ruta 5 Sur',
    category: 'Estructuras Metálicas',
    location: 'Ruta 5 Sur, Chile',
    year: '2023',
    area: '850 m²',
    description: 'Fabricación de estructuras metálicas especializadas para pasarelas peatonales y vehiculares a lo largo de la Ruta 5 Sur. Proyecto de infraestructura vial que incluyó el diseño, corte, soldadura, pintado anticorrosivo y montaje de estructuras de acero de alta resistencia para garantizar la seguridad vial en una de las rutas más importantes del país.',
    tags: ['Infraestructura vial', 'Estructura metálica', 'Pasarelas', 'Ruta 5 Sur'],
    img: 'https://i.imgur.com/0rRZpVb.jpeg',
    imgs: [
      'https://i.imgur.com/uLnFHwo.jpeg',
      'https://i.imgur.com/LsTZDNb.jpeg',
      'https://i.imgur.com/AaMHsxC.jpeg',
      'https://i.imgur.com/MSyB4iJ.jpeg',
      'https://i.imgur.com/b2VZYee.jpeg',
      'https://i.imgur.com/nXxqlKj.jpeg',
      'https://i.imgur.com/Yo2KaDv.jpeg',
      'https://i.imgur.com/vY42f1P.jpeg',
      'https://i.imgur.com/zdd3LeI.jpeg',
    ],
  },
  {
    id: 11,
    title: 'Galpón Fundo Normandia',
    category: 'Galpones Industriales',
    location: 'Temuco, Araucanía',
    year: '2022',
    area: '2.500 m²',
    description: 'Construcción de galpón industrial en Fundo Normandia, Temuco. El proyecto incluyó estructura metálica con cubierta, revestimientos laterales, fundaciones de hormigón y obras civiles integrales, con terminaciones de alta calidad para uso industrial y agrícola.',
    tags: ['Galpón industrial', 'Estructura metálica', 'Obras civiles', 'Fundo Normandia'],
    img: 'https://storage.readdy-site.link/project_files/e9e9255d-4fa4-42a2-878c-87b7e92a4901/ea14d3f9-c68d-4e51-b410-d73c108cf2cf_Galpon-fundo-normandia-3.jpeg?v=aa0fc9f3682549dfe87fa33049085bb3',
    imgs: [
      'https://storage.readdy-site.link/project_files/e9e9255d-4fa4-42a2-878c-87b7e92a4901/294f7867-f5d3-4142-9623-c1a778929b06_Galpon-Fundo-Normandia-1.jpeg?v=4737ec7ddfd4d17bdebf26939b9947db',
      'https://storage.readdy-site.link/project_files/e9e9255d-4fa4-42a2-878c-87b7e92a4901/808a4144-f474-4282-9766-b891b767e09e_Galpon-Fundo-Normandia-2.jpeg?v=0735ef49ef0e95fdd62bce6b06d7d51d',
      'https://storage.readdy-site.link/project_files/e9e9255d-4fa4-42a2-878c-87b7e92a4901/73c27655-ae71-46f9-b32c-5c400507ffa4_GALPON-FUNDO-NORMANDIA-4.jpeg?v=2c401ac821764be78a832e74a8f93fc9',
      'https://storage.readdy-site.link/project_files/e9e9255d-4fa4-42a2-878c-87b7e92a4901/722936d9-d01f-47a2-9b35-16c990c085c9_Galpon-Fundo-Normandia.jpeg?v=d424e959332be283fff8f5eaf0a0c3b7',
      'https://public.readdy.ai/ai/img_res/edited_93665d4c5098f15ab9c39263b76e7bda_41776496.jpg',
      'https://storage.readdy-site.link/project_files/e9e9255d-4fa4-42a2-878c-87b7e92a4901/db31be01-21a0-4478-983b-6ae3bec5d62e_Obras-civiles-General-Lopez-1.jpeg?v=4a6ea3202d36683173c1d85b3454d673',
    ],
  },
  {
    id: 12,
    title: 'Galpones Nestlé Temuco',
    category: 'Galpones Industriales',
    location: 'Temuco, Araucanía',
    year: '2021',
    area: '3.500 m²',
    description: 'Construcción de galpones con revestimiento para cadenas de frío para Nestlé en Temuco. Estructuras metálicas de gran envergadura diseñadas para cumplir con los estándares de calidad e higiene requeridos por la industria alimentaria, con sistemas de aislamiento térmico especializado para cadenas de frío.',
    tags: ['Industria alimentaria', 'Gran superficie', 'Estructura metálica'],
    img: 'https://i.imgur.com/x69Kdqn.jpg',
    imgs: [
      'https://i.imgur.com/UK1zlcj.jpg',
      'https://storage.readdy-site.link/project_files/e9e9255d-4fa4-42a2-878c-87b7e92a4901/344a8a5c-043e-4a3b-9f62-09d7ce1cc2d7_Galpon-revestido-para-frio-para-Nestle-Temuc-1.jpg?v=6f06a29e510d0227d3c443a303516925',
      'https://storage.readdy-site.link/project_files/e9e9255d-4fa4-42a2-878c-87b7e92a4901/d6fcc796-53a5-4a72-ba87-c32c381e1315_Galpon-revestido-para-frio-para-Nestle-Temuc-2.jpg?v=2b216be70664f2b1949c18f0bb9655c2',
      'https://storage.readdy-site.link/project_files/e9e9255d-4fa4-42a2-878c-87b7e92a4901/17095c8f-8b2f-491b-b6e8-4a3f4791dbb0_Galpon-revestido-para-frio-para-Nestle-Temuc-3.jpg?v=51d007c90092b2f552cd3b667b5bf516',
    ],
  },
  {
    id: 13,
    title: 'Proceso de Construcción para Instalaciones Constructora Luis Rubilar',
    category: 'Obras Civiles',
    location: 'Temuco, Araucanía',
    year: '2021',
    area: '3.000 m²',
    description: 'Proceso de construcción de instalaciones industriales para Constructora Luis Rubilar. Proyecto que incluyó obras civiles, fundaciones de hormigón armado, montaje de estructuras metálicas e instalaciones especializadas para operación industrial en la zona urbana de Temuco.',
    tags: ['Obras civiles', 'Constructora', 'Instalaciones industriales', 'Temuco'],
    img: 'https://i.imgur.com/vGEt9uL.jpeg',
    imgs: [
      'https://i.imgur.com/FiVnaAy.jpeg',
      'https://i.imgur.com/tRi7jll.jpeg',
      'https://i.imgur.com/JUUrkKi.jpeg',
      'https://i.imgur.com/6jiEGkL.jpeg',
      'https://i.imgur.com/I0CSpGP.jpeg',
      'https://i.imgur.com/NxC6tDm.jpeg',
    ],
  },
  {
    id: 14,
    title: 'Supermercado La Estrella',
    category: 'Locales Comerciales',
    location: 'Cunco, Araucanía',
    year: '2020',
    area: '900 m²',
    description: 'Construcción terminada de supermercado La Estrella en Cunco. Obra completa con estructura metálica, cubierta, revestimientos, instalaciones eléctricas y sanitarias, entregada llave en mano.',
    tags: ['Supermercado', 'Llave en mano', 'Obra completa'],
    img: 'https://storage.readdy-site.link/project_files/e9e9255d-4fa4-42a2-878c-87b7e92a4901/64d0afb0-8631-4b3e-8901-cbb51bb40514_Supmercado-la-Estrella-Cunco-1.jpg?v=d1373a26d0118649fe7ab2dea280c706',
    imgs: [
      'https://storage.readdy-site.link/project_files/e9e9255d-4fa4-42a2-878c-87b7e92a4901/751c276a-9335-48c0-af85-45c75c4280b1_Supmercado-la-Estrella-Cunco-2.jpg?v=ad85d6cbfe48421d4af9c2d6a1817fdf',
      'https://storage.readdy-site.link/project_files/e9e9255d-4fa4-42a2-878c-87b7e92a4901/7ad07c4b-6dcd-45cf-a227-0494430dbe0d_Supmercado-la-Estrella-Cunco-3.jpg?v=81706738a2be13a86cd9b6901aaaac7a',
      'https://storage.readdy-site.link/project_files/e9e9255d-4fa4-42a2-878c-87b7e92a4901/2ee625f7-171c-4721-ac0a-36a6b40ff433_Supmercado-la-Estrella-Cunco-4.jpg?v=4597f9cf2c98014ec22550799bb5b607',
      'https://storage.readdy-site.link/project_files/e9e9255d-4fa4-42a2-878c-87b7e92a4901/0a99efa0-2800-4501-9b40-81b82492f7e1_Supmercado-la-Estrella-Cunco-5.jpg?v=c8954f20d64354e0d806b924a9b236fc',
      'https://storage.readdy-site.link/project_files/e9e9255d-4fa4-42a2-878c-87b7e92a4901/9d30c929-8ddf-4098-8d68-adde55891c55_Supmercado-la-Estrella-Cunco-6.jpg?v=0d5117f849bf419620ee8c3cd40e8bbe',
    ],
  },
  {
    id: 15,
    title: 'Proceso de Construcción Piscicultura Melipeuco',
    category: 'Piscicultura',
    location: 'Melipeuco, Araucanía',
    year: '2020',
    area: '1.200 m²',
    description: 'Ampliación y modernización de instalaciones de piscicultura en Melipeuco. Proyecto de infraestructura acuícola con nuevas estructuras metálicas para procesamiento y almacenamiento, adaptadas a las exigentes condiciones del entorno.',
    tags: ['Acuicultura', 'Ampliación', 'Infraestructura acuícola', 'Melipeuco'],
    img: 'https://storage.readdy-site.link/project_files/e9e9255d-4fa4-42a2-878c-87b7e92a4901/1a1180e3-da2f-4de0-9a68-088e035717ea_Psicultura-melipeuco-ao-2020-1.jpg?v=ae2c190ba12e02e7198ca4c2dc4cac71',
    imgs: [
      'https://storage.readdy-site.link/project_files/e9e9255d-4fa4-42a2-878c-87b7e92a4901/302c770d-cce4-47bb-b97e-a9b74866970d_Psicultura-melipeuco-ao-2020-2.jpg?v=41877a7d3bd7587c3ba4314e9989d996',
      'https://i.imgur.com/7x5Ybbn.jpeg',
      'https://i.imgur.com/ItJ6PYP.jpeg',
      'https://i.imgur.com/OVk3Ojh.jpeg',
      'https://i.imgur.com/0aNSyKh.jpeg',
      'https://i.imgur.com/kpu2chC.jpeg',
      'https://i.imgur.com/XC3wqoo.jpeg',
    ],
  },
  {
    id: 16,
    title: 'Galpón Multipropósito Fundo San Sebastián',
    category: 'Galpones Industriales',
    location: 'Fundo San Sebastián, Villarrica',
    year: '2019',
    area: '1.600 m²',
    description: 'Galpón multipropósito de estructura metálica construido en el Fundo San Sebastián, Villarrica. Estructura de alta calidad diseñada para uso agrícola e industrial, con cubierta, revestimientos laterales y todas las instalaciones necesarias para operación inmediata en la zona de la Araucanía.',
    tags: ['Obra terminada', 'Estructura metálica', 'Listo para operar', 'Fundo San Sebastián'],
    img: 'https://i.imgur.com/VvhUNri.jpg',
    imgs: [
      'https://imgur.com/cASLe3x.jpg',
      'https://imgur.com/krwBFlV.jpg',
    ],
  },
  {
    id: 17,
    title: 'Concesionaria Volvo Temuco',
    category: 'Locales Comerciales',
    location: 'Temuco, Araucanía',
    year: '2019',
    area: '1.800 m²',
    description: 'Construcción completa de concesionaria oficial Volvo en Temuco. Proyecto de alta exigencia con terminaciones de primer nivel, fachada corporativa con logo oficial, amplios espacios interiores para exhibición de vehículos y zonas de servicio técnico.',
    tags: ['Concesionaria', 'Fachada corporativa', 'Terminaciones premium'],
    img: 'https://i.imgur.com/tl7d4Yb.jpg',
    imgs: [
      'https://i.imgur.com/qZEjBgK.jpg',
      'https://storage.readdy-site.link/project_files/e9e9255d-4fa4-42a2-878c-87b7e92a4901/ea49f275-aa6c-4ce5-b51f-4b32582127aa_Volvo-Temuco-18.jpg?v=56c3d9fa02a0f588140c57da96ec3e6e',
      'https://i.imgur.com/SWEZb8d.jpg',
      'https://i.imgur.com/jRrMdcJ.jpg',
      'https://i.imgur.com/dIukbyS.jpg',
      'https://i.imgur.com/2nLZxXO.jpg',
      'https://i.imgur.com/3vNNjw9.jpg',
      'https://i.imgur.com/i4BpvFq.jpg',
      'https://i.imgur.com/6r4uaqd.jpg',
    ],
  },
  {
    id: 18,
    title: 'Mall Chino Torremolino Temuco',
    category: 'Locales Comerciales',
    location: 'Temuco, Araucanía',
    year: '2019',
    area: '1.500 m²',
    description: 'Construcción del Mall Chino Torremolino en Temuco. Centro comercial con múltiples locales, amplios espacios de circulación y terminaciones modernas orientadas al comercio minorista y mayorista.',
    tags: ['Mall comercial', 'Retail', 'Locales múltiples', 'Torremolino'],
    img: 'https://storage.readdy-site.link/project_files/e9e9255d-4fa4-42a2-878c-87b7e92a4901/64f4c647-dad6-4451-8010-d4d5ed258420_Mall-chino-Torremolino-Temuco-7.jpg?v=ea78bdcaaecd4fb14797bfd8d19c2d15',
    imgs: [
      'https://storage.readdy-site.link/project_files/e9e9255d-4fa4-42a2-878c-87b7e92a4901/2b531fe5-d376-4d73-a504-52513260fc28_Mall-chino-Torremolino-Temuco-5.jpg?v=be2831b34d40a7aa43b3130921e3f492',
      'https://storage.readdy-site.link/project_files/e9e9255d-4fa4-42a2-878c-87b7e92a4901/ee364012-4ea3-4f33-abcf-71cbf2d37cbf_Mall-chino-Torremolino-Temuco-6.jpg?v=41672743fe0e94e18abab774a7174650',
      'https://storage.readdy-site.link/project_files/e9e9255d-4fa4-42a2-878c-87b7e92a4901/2c457e0f-e26e-45ce-9f1a-ad67cfb0ff46_IMG_20191005_142939.jpg?v=93b608ddf790fc9b9e3429ed77569a2a',
      'https://storage.readdy-site.link/project_files/e9e9255d-4fa4-42a2-878c-87b7e92a4901/23d58185-2659-4abd-8730-d79ffde5d9f4_IMG_20191007_174614.jpg?v=e1e1024ec469002293ba863ec47ca725',
    ],
    videos: [
      'https://storage.readdy-site.link/project_files/e9e9255d-4fa4-42a2-878c-87b7e92a4901/e826bae9-ae17-4e3b-9f8d-ccf3cd124eb9_Video-terminacion-Mall-chino-torremolino-Temuco.mp4?v=a10ee4d2d87bbafcbe2015bda4edf971',
    ],
  },
  {
    id: 19,
    title: 'Galpón Pio Seco',
    category: 'Galpones Industriales',
    location: 'Pio Seco, Araucanía',
    year: '2019',
    area: '1.200 m²',
    description: 'Construcción de galpón industrial en Pio Seco. Estructura metálica con cubierta, revestimientos laterales y terminaciones de alta calidad para uso industrial y agrícola en la zona rural de la Araucanía.',
    tags: ['Galpón industrial', 'Estructura metálica', 'Uso agrícola', 'Pio Seco'],
    img: 'https://public.readdy.ai/ai/img_res/edited_d82444b2651417bfd6bb2e4876268877_6ceb17ba.jpg',
    imgs: [],
  },
  {
    id: 20,
    title: 'Local Comercial Mercato',
    category: 'Locales Comerciales',
    location: 'Temuco, Araucanía',
    year: '2018',
    area: '650 m²',
    description: 'Se realizó un trabajo de infraestructura para local Mercato Temuco. Construcción de estructura metálica, cubierta, revestimientos y terminaciones completas para el funcionamiento del local comercial en el centro de la ciudad.',
    tags: ['Local comercial', 'Retail', 'Terminaciones modernas'],
    img: 'https://i.imgur.com/LompBnl.jpg',
    imgs: [
      'https://i.imgur.com/gnAvK0m.jpg',
    ],
  },
  {
    id: 21,
    title: 'Galpón Industrial Fundo Aguasbuenas',
    category: 'Galpones Industriales',
    location: 'Temuco, Araucanía',
    year: '2018',
    area: '2.200 m²',
    description: 'Construcción de galpón industrial en Fundo Aguasbuenas. Estructura metálica con cubierta, revestimientos laterales y terminaciones de alta calidad para uso industrial y logístico. Proyecto que demuestra nuestra capacidad para obras de gran envergadura en el sector agrícola e industrial.',
    tags: ['Galpón industrial', 'Estructura metálica', 'Uso logístico', 'Fundo Aguasbuenas'],
    img: 'https://storage.readdy-site.link/project_files/e9e9255d-4fa4-42a2-878c-87b7e92a4901/46bfcd2d-241e-43a4-a1ef-777c8fa883f9_Infraestructura-Fundo-Aguasbuenas-6.jpg?v=c65c629874b211fbc5d14b0e99ad3116',
    imgs: [
      'https://storage.readdy-site.link/project_files/e9e9255d-4fa4-42a2-878c-87b7e92a4901/b3d0fe10-1423-421f-bc23-8a38552efe7a_Infraestructura-Fundo-Aguasbuenas-1.jpg?v=3acef489f24f867832c65c623b371623',
      'https://storage.readdy-site.link/project_files/e9e9255d-4fa4-42a2-878c-87b7e92a4901/b8d09488-da37-4925-85ee-9cbdf2477811_Infraestructura-Fundo-Aguasbuenas-2.jpg?v=d5d1c3ec8cf55750fc0841cff3ff0de1',
      'https://storage.readdy-site.link/project_files/e9e9255d-4fa4-42a2-878c-87b7e92a4901/dc4fe1e3-3c49-423a-a65b-77730dce5e3d_Infraestructura-Fundo-Aguasbuenas-3.jpg?v=6f015de5c8f6769045b7b4a10ccfc841',
      'https://storage.readdy-site.link/project_files/e9e9255d-4fa4-42a2-878c-87b7e92a4901/144542fd-2d6f-4dc8-a470-b6c4d355fa71_Infraestructura-Fundo-Aguasbuenas-4.jpg?v=870cb3a0305dc025f8e4a2353e8fce66',
      'https://storage.readdy-site.link/project_files/e9e9255d-4fa4-42a2-878c-87b7e92a4901/2fd175df-dd5a-4c28-bc21-e5b8608df4c3_Infraestructura-Fundo-Aguasbuenas-5.jpg?v=ac6f756d3a22f6c1e50586f25958d462',
    ],
  },
  {
    id: 27,
    title: 'Gimnasio BlackHouse Temuco',
    category: 'Locales Comerciales',
    location: 'Temuco, Araucanía',
    year: '2018',
    area: '750 m²',
    description: 'Construcción de gimnasio BlackHouse en Temuco. Proyecto de uso deportivo con amplios espacios interiores, estructura metálica y terminaciones de calidad orientadas al bienestar y el deporte.',
    tags: ['Gimnasio', 'Uso deportivo', 'Espacios amplios'],
    img: 'https://storage.readdy-site.link/project_files/e9e9255d-4fa4-42a2-878c-87b7e92a4901/761a55f7-2120-45ad-be38-71ffe6dbd233_Gym-BlackHouse-Temuco-1.jpg?v=ab1b86c0aea41d2e3ad5809041252c42',
    imgs: [
      'https://i.imgur.com/AOljfAU.jpg',
      'https://i.imgur.com/JhAgupp.jpg',
    ],
  },
  {
    id: 22,
    title: 'FABRICACION Y MONTAJE DE SILOS 100 TONELADAS A MOLINERA NACIONAL',
    category: 'Estructuras Metálicas',
    location: 'General López, Araucanía',
    year: '2017',
    area: '1.400 m²',
    description: 'Fabricación y montaje de silos de 100 toneladas para Molinera Nacional en General López. El proyecto incluyó la construcción del molino de acecho, fabricación de tubulares para almacenamiento de trigo, pintado anticorrosivo y ensamblaje de la estructura metálica para procesamiento agrícola, garantizando durabilidad y resistencia para operación continua en el sector rural.',
    tags: ['Tubulares', 'Molino industrial', 'Almacenamiento agrícola', 'Anticorrosión'],
    img: 'https://i.imgur.com/Ngxxbnx.jpg',
    imgs: [
      'https://i.imgur.com/0DD5Qce.jpg',
      'https://i.imgur.com/ef6CrKW.jpg',
      'https://storage.readdy-site.link/project_files/e9e9255d-4fa4-42a2-878c-87b7e92a4901/d94b85a8-5041-45d8-b121-eb30f6dea3b4_Molino-de-acecho-Fundo-traico-general-Lopez-5.jpg?v=6221d5603b1da9ebe9d70d6c54ffc99b',
      'https://i.imgur.com/MH4UodT.jpeg',
      'https://i.imgur.com/wW8cAmB.jpeg',
      'https://i.imgur.com/N9dsW2c.jpeg',
      'https://i.imgur.com/zRPdNA0.jpeg',
      'https://i.imgur.com/Jl393JX.jpeg',
      'https://i.imgur.com/KyydILJ.jpeg',
    ],
  },
  {
    id: 23,
    title: 'Galpón Industrial en Proceso',
    category: 'Galpones Industriales',
    location: 'Temuco, Araucanía',
    year: '2016',
    area: '1.400 m²',
    description: 'Construcción en proceso de galpón industrial de estructura metálica. Proyecto de mediana envergadura con cubierta de zinc, revestimiento lateral y fundaciones de hormigón armado para uso logístico.',
    tags: ['En construcción', 'Estructura metálica', 'Uso logístico'],
    img: 'https://public.readdy.ai/ai/img_res/edited_6bc05bb7b9e002c1d2957631a79747bb_f55c2b65.jpg',
    imgs: [
      'https://i.imgur.com/YxIeC4o.jpg',
    ],
  },
  {
    id: 24,
    title: 'Piscicultura Melipeuco',
    category: 'Piscicultura',
    location: 'Melipeuco, Araucanía',
    year: '2014',
    area: '800 m²',
    description: 'Construcción de instalaciones para piscicultura en Melipeuco. Proyecto especializado que incluye galpones de procesamiento, obras civiles adaptadas al entorno acuático y sistemas de infraestructura para la producción acuícola.',
    tags: ['Acuicultura', 'Obras especializadas', 'Infraestructura acuícola'],
    img: 'https://public.readdy.ai/ai/img_res/edited_a6502e8c0cf1305ce4ccf4ed95063b40_b020577a.jpg',
    imgs: [],
  },
  {
    id: 25,
    title: 'Minera El Toqui — Segunda Etapa',
    category: 'Minería',
    location: 'Coyhaique, Aysén',
    year: '2009',
    area: '2.200 m²',
    description: 'Segundo contrato con Minera El Toqui en Coyhaique. Ampliación y construcción de nuevas estructuras industriales para la mina. Proyecto ejecutado con los más altos estándares de seguridad, consolidando la relación de largo plazo con la industria minera.',
    tags: ['Minería', 'Ampliación industrial', 'Seguridad certificada'],
    img: 'https://public.readdy.ai/ai/img_res/edited_18af83aa6f67b9375e046c37c41673f5_ef653dd6.jpg',
    imgs: [
      'https://storage.readdy-site.link/project_files/e9e9255d-4fa4-42a2-878c-87b7e92a4901/f35674dc-7358-4c77-a8b5-5c673838a96c_Obras-realizadas-para-minera-el-toqui-Coyhaique-7.jpg?v=a4413fb89cd4081350698980fc01f69c',
      'https://storage.readdy-site.link/project_files/e9e9255d-4fa4-42a2-878c-87b7e92a4901/7e8ba393-aeb7-426b-af94-5dfe4bca5030_Obras-realizadas-para-minera-el-toqui-Coyhaique-9.jpg?v=aaae2cd33ee1893f86a257119a4dd6ce',
    ],
  },
  {
    id: 26,
    title: 'Minera El Toqui — Primera Etapa',
    category: 'Minería',
    location: 'Coyhaique, Aysén',
    year: '2006',
    area: '1.800 m²',
    description: 'Primer contrato con Minera El Toqui en Coyhaique. Construcción de estructuras industriales y galpones de apoyo para operaciones mineras. Proyecto de alta exigencia técnica en entorno minero, con estructuras diseñadas para soportar condiciones climáticas extremas de la Patagonia chilena.',
    tags: ['Minería', 'Alta exigencia técnica', 'Estructura industrial'],
    img: 'https://public.readdy.ai/ai/img_res/edited_52ec4053fe6ef5e1efac3885859bca4c_ef653dd6.jpg',
    imgs: [
      'https://storage.readdy-site.link/project_files/e9e9255d-4fa4-42a2-878c-87b7e92a4901/738dd015-ea9d-4a3e-878c-21d646b2c5d7_Obras-realizadas-para-minera-el-toqui-Coyhaique-3.jpg?v=62d8d6d2b7e1bd06086bf291414e8a7c',
      'https://storage.readdy-site.link/project_files/e9e9255d-4fa4-42a2-878c-87b7e92a4901/9650c6f0-d090-419b-8d17-3e874e4dc3c1_Obras-realizadas-para-minera-el-toqui-Coyhaique-5.jpg?v=eb0ab86463e59e1de2dba9f332234658',
    ],
  },
];

export const projectCategories = ['Todos', 'Minería', 'Galpones Industriales', 'Locales Comerciales', 'Piscicultura', 'Estructuras Metálicas', 'Obras Civiles'];